export const Waveform = ({ levels, active, className = "", testId = "waveform" }) => (
  <div className={`flex items-center justify-between gap-[3px] h-10 ${className}`} data-testid={testId}>
    {levels.map((l, i) => (
      <span
        key={i}
        className={`flex-1 min-w-[3px] max-w-[6px] rounded-full transition-[height,background-color] duration-100 ${active ? "bg-[var(--accent)]" : "bg-white/15"}`}
        style={{ height: `${Math.max(8, l * 100)}%` }}
      />
    ))}
  </div>
);
